<template>
  <div class="cm-odts">
    <v-data-table
      :headers="headers"
      :items="InformadorODTData"
      :loading="InformadorODTLoading"
      :item-class="itemRowClass"
      @click:row="seleccionarODT"
    >
      <template v-slot:top>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12">
              <v-expansion-panels>
                <v-expansion-panel>
                  <v-expansion-panel-header>
                    Filtros
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row dense v-if="!InformadorODTLoading">
                      <v-col cols="12" md="4" sm="6">
                        <v-text-field v-model="nuevoIdODT" label="Agregar ID ODT" type="number" min="1" clearable
                          hide-details @keydown.enter.prevent="agregarIdODT">
                          <template v-slot:append>
                            <v-btn x-small color="primary" @click="agregarIdODT">
                              Agregar
                            </v-btn>
                          </template>
                        </v-text-field>
                      </v-col>

                      <v-col cols="12" md="8" sm="6" class="d-flex align-center flex-wrap">
                        <v-chip v-for="idODT in InformadorODTFiltros.IdsODT" :key="`idodt-${idODT}`" small close
                          class="ma-1" @click:close="eliminarIdODT(idODT)">
                          {{ idODT }}
                        </v-chip>
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <v-text-field v-model="InformadorODTFiltros.Clave" text="Clave" clearable/>
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaEntregaInicio"
                          label="Fecha entrega inicio" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader
                          overlay buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaEntregaFin"
                          :min-date="InformadorODTFiltros.FechaEntregaInicio" label="Fecha entrega fin"
                          format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader overlay
                          buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaCreacionInicio"
                          label="Fecha creacion inicio" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader
                          overlay buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaCreacionFin"
                          :min-date="InformadorODTFiltros.FechaCreacionInicio" label="Fecha creacion fin"
                          format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader overlay
                          buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaInicioProduccionInicio"
                          label="Fecha inicio produccion inicio" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
                          noHeader overlay buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaInicioProduccionFin"
                          :min-date="InformadorODTFiltros.FechaInicioProduccionInicio"
                          label="Fecha inicio produccion fin" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
                          noHeader overlay buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaInicioDeProduccionInicio"
                          label="Fecha inicio de produccion inicio" format="YYYY-MM-DD HH:mm"
                          formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaInicioDeProduccionFin"
                          :min-date="InformadorODTFiltros.FechaInicioDeProduccionInicio"
                          label="Fecha inicio de produccion fin" format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm"
                          noHeader overlay buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaReemplazo" label="Fecha reemplazo"
                          format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader overlay
                          buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaInicio" label="Fecha inicio"
                          format="YYYY-MM-DD HH:mm" formatted="YYYY-MM-DD HH:mm" noHeader overlay
                          buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <VueCtkDateTimePicker v-model="InformadorODTFiltros.FechaFin"
                          :min-date="InformadorODTFiltros.FechaInicio" label="Fecha fin" format="YYYY-MM-DD HH:mm"
                          formatted="YYYY-MM-DD HH:mm" noHeader overlay buttonNowTranslation="Ahora" />
                      </v-col>

                      <v-col cols="12" md="3" sm="6">
                        <v-autocomplete v-model="InformadorODTFiltros.Condicion" :items="condicionItems"
                          item-text="text" item-value="value" text="Condición" clearable />
                      </v-col>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>

            <v-col cols="12" class="d-flex justify-end">
              <v-btn color="purple" @click="InformadorODT" :loading="InformadorODTLoading">
                Buscar
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </template>

      <template v-slot:item.fechaCreacion="{ item }">
        <span class="fecha-texto">{{ separarFechaHora(item.fechaCreacion).fecha }}</span>
        <span class="hora-texto">{{ separarFechaHora(item.fechaCreacion).hora }}</span>
      </template>

      <template v-slot:item.fechaEntrega="{ item }">
        <span class="fecha-texto">{{ separarFechaHora(item.fechaEntrega).fecha }}</span>
        <span class="hora-texto">{{ separarFechaHora(item.fechaEntrega).hora }}</span>
      </template>

      <template v-slot:item.fechaInicioProduccion="{ item }">
        <span class="fecha-texto">{{ separarFechaHora(item.fechaInicioProduccion).fecha }}</span>
        <span class="hora-texto">{{ separarFechaHora(item.fechaInicioProduccion).hora }}</span>
      </template>

      <template v-slot:item.fechaInicioDeProduccion="{ item }">
        <span class="fecha-texto">{{ separarFechaHora(item.fechaInicioDeProduccion).fecha }}</span>
        <span class="hora-texto">{{ separarFechaHora(item.fechaInicioDeProduccion).hora }}</span>
      </template>
    </v-data-table>

    <DialogODTs_Operaciones
      v-model="dialogODTsOperaciones"
      :odt="odtSeleccionada"
    />
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import DialogODTs_Operaciones from "./DialogODTs_Operaciones.vue";

function createFiltros() {
  return {
    Clave: null,
    FechaEntregaInicio: null,
    FechaEntregaFin: null,
    FechaCreacionInicio: null,
    FechaCreacionFin: null,
    FechaInicioProduccionInicio: null,
    FechaInicioProduccionFin: null,
    FechaInicioDeProduccionInicio: null,
    FechaInicioDeProduccionFin: null,
    FechaReemplazo: null,
    FechaInicio: null,
    FechaFin: null,
    IdsODT: [],
    Condicion: null,
  };
}

export default {
  name: "ControlMaestroODTs",

  components: {
    DialogODTs_Operaciones,
  },

  data() {
    return {
      headers: [
        {
          text: "Id Trabajo Orden",
          value: "idTrabajoOrden",
          align: "center",
          sortable: true,
        },
        {
          text: "Clave",
          value: "clave",
          align: "center",
          sortable: true,
        },
        {
          text: "Fecha Creacion",
          value: "fechaCreacion",
          align: "center",
          sortable: true,
        },
        {
          text: "Fecha Entrega",
          value: "fechaEntrega",
          align: "center",
          sortable: true,
        },
        {
          text: "Fecha Inicio Produccion",
          value: "fechaInicioProduccion",
          align: "center",
          sortable: true,
        },
        {
          text: "Fecha Inicio De Produccion",
          value: "fechaInicioDeProduccion",
          align: "center",
          sortable: true,
        }, {
          text: "Condicion",
          value: "condicion",
          align: "center",
          sortable: true,
        },
      ],
      condicionItems: [
        {
          text: "Activa",
          value: true,
        }, {
          text: "Inactiva",
          value: false,
        }
      ],
      nuevoIdODT: null,
      InformadorODTFiltros: createFiltros(),
      InformadorODTData: [],
      InformadorODTLoading: false,
      dialogODTsOperaciones: false,
      odtSeleccionada: null,
    };
  },

  methods: {
    itemRowClass() {
      return "odt-row-clickable";
    },

    seleccionarODT(item) {
      const odt = item && item.item ? item.item : item;
      if (!odt || typeof odt !== "object") return;

      this.odtSeleccionada = odt;
      this.dialogODTsOperaciones = true;
    },

    reset() {
      this.nuevoIdODT = null;
      this.InformadorODTFiltros = createFiltros();
      this.InformadorODTData = [];
      this.InformadorODTLoading = false;
      this.dialogODTsOperaciones = false;
      this.odtSeleccionada = null;
    },

    agregarIdODT() {
      const idODT = Number(this.nuevoIdODT);
      if (!Number.isInteger(idODT) || idODT <= 0) return;

      if (this.InformadorODTFiltros.IdsODT.includes(idODT)) {
        this.nuevoIdODT = null;
        return;
      }

      this.InformadorODTFiltros.IdsODT = [...this.InformadorODTFiltros.IdsODT, idODT].sort((a, b) => a - b);
      this.nuevoIdODT = null;
    },

    eliminarIdODT(idODT) {
      this.InformadorODTFiltros.IdsODT = this.InformadorODTFiltros.IdsODT.filter((id) => id !== idODT);
    },

    formatearFechaHoraISO(valor) {
      if (valor === null || valor === undefined || valor === "") {
        return "";
      }

      const texto = String(valor).trim();
      const coincidencia = texto.match(/^(\d{4}-\d{2}-\d{2})[T\s](\d{2}:\d{2}(?::\d{2})?)/);

      if (coincidencia) {
        const hora = coincidencia[2].length === 5 ? `${coincidencia[2]}:00` : coincidencia[2];
        return `${coincidencia[1]} ${hora}`;
      }

      const fecha = new Date(texto);
      if (Number.isNaN(fecha.getTime())) {
        return texto;
      }

      const pad = (numero) => String(numero).padStart(2, "0");
      return `${fecha.getFullYear()}-${pad(fecha.getMonth() + 1)}-${pad(fecha.getDate())} ${pad(fecha.getHours())}:${pad(fecha.getMinutes())}:${pad(fecha.getSeconds())}`;
    },

    separarFechaHora(valor) {
      const fechaHora = this.formatearFechaHoraISO(valor);
      if (!fechaHora) {
        return { fecha: "-", hora: "" };
      }

      const [fecha, hora] = fechaHora.split(/[T\s]/);
      return {
        fecha: fecha || "-",
        hora: hora || "",
      };
    },

    async InformadorODT() {
      this.InformadorODTLoading = true;

      try {
        this.InformadorODTData = [];

        const response = await axios.get("ControlMaestro/InformadorODT", {
          params: this.InformadorODTFiltros,
          paramsSerializer: (params) => qs.stringify(params, { indices: false, skipNulls: true }),
        });

        this.InformadorODTData = Array.isArray(response.data?.ordenesTrabajo)
          ? response.data.ordenesTrabajo
          : [];
      } catch (error) {
        this.InformadorODTData = [];
        console.error("Error al obtener InformadorODT:", error);
      } finally {
        this.InformadorODTLoading = false;
      }
    },
  },
};
</script>

<style scoped>
.cm-odts ::v-deep tbody tr.odt-row-clickable {
  cursor: pointer;
}

.fecha-texto {
  color: #1565c0;
  font-weight: 600;
}

.hora-texto {
  color: #ef6c00;
  font-weight: 600;
}
</style>
